import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetch_vendor_walk_plans,
  accept_walk_plan,
  reject_walk_plan,
  preview_walk_plan,
  create_walk_plan,
  pay_walk_plan,
  verify_walk_plan_payment,
  fetch_my_walk_plans,
  cancel_walk_plan,
} from './api';
import type { WalkPlanSchedule, CreateWalkPlanRequest, VerifyPlanPaymentRequest } from './types';

export function use_vendor_walk_plans() {
  return useQuery({
    queryKey: ['vendor-walk-plans'],
    queryFn: fetch_vendor_walk_plans,
  });
}

export function use_my_walk_plans() {
  return useQuery({
    queryKey: ['my-walk-plans'],
    queryFn: fetch_my_walk_plans,
  });
}

export function use_accept_walk_plan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => accept_walk_plan(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['vendor-walk-plans'] });
      qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
    },
  });
}

export function use_reject_walk_plan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) => reject_walk_plan(id, reason),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['vendor-walk-plans'] });
      qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
    },
  });
}

export function use_preview_walk_plan() {
  return useMutation({ mutationFn: (input: WalkPlanSchedule) => preview_walk_plan(input) });
}

export function use_create_walk_plan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateWalkPlanRequest) => create_walk_plan(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-walk-plans'] }),
  });
}

export function use_pay_walk_plan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => pay_walk_plan(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-walk-plans'] });
      qc.invalidateQueries({ queryKey: ['my-bookings'] });
    },
  });
}

export function use_verify_walk_plan_payment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: VerifyPlanPaymentRequest }) => verify_walk_plan_payment(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-walk-plans'] });
      qc.invalidateQueries({ queryKey: ['my-bookings'] });
    },
  });
}

export function use_cancel_walk_plan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) => cancel_walk_plan(id, reason),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-walk-plans'] });
      qc.invalidateQueries({ queryKey: ['my-bookings'] });
    },
  });
}
